import { Divider as AntDivider } from 'antd';
import styled from 'styled-components';

export const Divider = styled(AntDivider)`
  &.timer-detail {
    width: calc(var(--viewport-width) - 20px);
    margin-inline: -10px;
  }
  &.ant-divider-vertical {
    margin: 0;
    height: auto;
    &.timer-divider {
      height: 24px;
      margin-inline: 0;
    }
  }
`;
